import { IInitialFormData, TTypeOfEditScheduleModalWindow } from './editScheduleModalState/editScheduleModalContext';
import { RestaurantNotificationEventType, IEditScheduledPush, TScheduledPushStatus } from 'types';

export enum EditScheduleActionTypes {
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_SCHEDULE = 'CHANGE_SCHEDULE',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetInitialFormData {
	type: EditScheduleActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditScheduleActionTypes.SET_ALL_DATA;
	payload: {
		id: string;
		type: RestaurantNotificationEventType | null;
		status: TScheduledPushStatus | null;
		scheduledDateTime: string;
		restaurantsIds: string[];
	};
}

interface IChangeSchedule {
	type: EditScheduleActionTypes.CHANGE_SCHEDULE;
	payload: {
		schedule: string;
	};
}

interface ISetDataForSubmit {
	type: EditScheduleActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditScheduledPush | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditScheduleActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditScheduleModalWindow;
	};
}

interface IResetSelectedControls {
	type: EditScheduleActionTypes.RESET_FIELDS;
}

export type TEditScheduleAction =
	| ISetInitialFormData
	| ISetAllData
	| IChangeSchedule
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
